import * as React from "react";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import KuikaSmallText from "../../ui-kit/typography/SmallText/SmallText";
import KuikaTextMedium from "../../ui-kit/typography/TextMedium/TextMedium";

interface LibraryDetailProps {
  name: string;
  version?: string;
  description?: string;
  /** Primary control for this item — Add / Installed flag (browse) or Remove (installed). */
  action?: React.ReactNode;
  onBack: () => void;
  /** Extra section rendered under the description, e.g. the installed version switcher. */
  children?: React.ReactNode;
}

/**
 * Shared detail page (à la the VS Code extension view) for a single library, used by both the browse
 * and installed tabs. It owns the layout — back link, icon, name + version, action slot, the full
 * unclamped description — and accepts the context-specific action and an optional extra section.
 */
const LibraryDetail: React.FC<LibraryDetailProps> = ({ name, version, description, action, onBack, children }) => (
  <div className="kuika-external-libraries__detail">
    <KuikaButton type="text" size="sm" onClick={onBack} className="kuika-external-libraries__back">
      <span className="kuika-external-libraries__back-inner">
        <KuikaSvg name="chevron-left" type="arrows" width={16} height={16} />
        Back
      </span>
    </KuikaButton>

    <div className="kuika-external-libraries__detail-head">
      <span className="kuika-external-libraries__detail-icon">
        <KuikaSvg name="package" width={20} height={20} />
      </span>
      <div className="kuika-external-libraries__detail-title">
        <KuikaTextMedium className="kuika-external-libraries__detail-name">{name}</KuikaTextMedium>
        {version && <span className="kuika-external-libraries__version-chip">{version}</span>}
      </div>
      {action}
    </div>

    <KuikaSmallText className="kuika-external-libraries__detail-desc">
      {description || "No description provided for this package."}
    </KuikaSmallText>

    {children}
  </div>
);

export default LibraryDetail;
